import checkSkipStep from "./check-skip-step";
import increaseOffsetIteration from "./increase-offset-iteration";
import deleteActiveTriggers from "./on-step-status/delete-active-triggers";
import resetOffsetIterations from "./reset-offset-iterations";
import resetTimelineProperties from "./reset-timeline-properties";

/**
 * Iterate or reset iteration of the offset timeline
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {MainClassProps} main
 * @param {Boolean} enter
 * @param {Number} iterations
 */
const iterateTimeline = (trigger, timeline, main, enter, iterations) => {
  /** Current timeline iterations */
  let iteration = /** @type {Number} */ (timeline.get("current-iteration"));

  /** Timeline is still iterating (not finished) */
  const iterating = iteration < iterations - 1;

  /** Should skip the first step */
  const skip = timeline.get("o_skip-first");

  /** Still needs to iterate */
  if (iterating && trigger.get("is-active")) {
    increaseOffsetIteration(trigger, timeline, enter, iteration);

    if (skip) {
      checkSkipStep(trigger, timeline);
    } else {
      resetTimelineProperties(main, trigger, timeline);
    }

    return false;
  } else {
    resetOffsetIterations(timeline, enter);
    deleteActiveTriggers(main, trigger);

    return true;
  }
};

export default iterateTimeline;
